import { DragEndEvent } from '@dnd-kit/core';
import { useCallback } from 'react';
import { useSaveGanttDropTaskMutation } from '../../../../../queryHooks/productionPlanHooks';
import { DroppableData, NodeType } from '../../Gantt/types';
import { useSimulationId } from './useSimulationId';
import { GanttDraggableData } from '../../Gantt/hooks';

export const useGanttSimulationOnDragEnd = () => {
  const saveDropTaskMutation = useSaveGanttDropTaskMutation();
  const { id } = useSimulationId();

  const onDragEnd = useCallback(
    (evt: DragEndEvent) => {
      if (evt.over) {
        const { id: droppedTaskId } = evt.active;
        const data = evt.active.data.current as GanttDraggableData | undefined;
        const current = evt.over.data.current as DroppableData | undefined;

        if (current) {
          saveDropTaskMutation.mutate({
            taskId: Number(droppedTaskId),
            queueId: current.queueId,
            predecessorTaskId: current.predecessorTaskId,
            simulationId: id,
            type: data?.type ?? NodeType.TASK,
          });
        }
      }
    },
    [saveDropTaskMutation, id],
  );

  return onDragEnd;
};
